import { createTheme } from '@mui/material';
import { enUS, Localization, ruRU } from '@mui/material/locale';
import createPalette from '@mui/material/styles/createPalette';
import { UnderscoreLocale } from 'mir-utils/i18n';
import { notUndefined } from 'mir-utils/utils/utilities';
import { BrandThemeColors } from '__generated__/version';
import { enUS as DataGridEn, GridLocaleText, ruRU as DataGridRu } from '@mui/x-data-grid-pro';
import { getOverrides } from './overrides';

// interface не экспортируется из библиотеки
interface GridLocalization {
  components: {
    MuiDataGrid: {
      defaultProps: {
        localeText: Partial<GridLocaleText>;
      };
    };
  };
}

const gridLocalesMap = new Map<UnderscoreLocale, GridLocalization>([
  ['ru_RU', DataGridRu],
  ['en_US', DataGridEn],
]);

const localesMap = new Map<UnderscoreLocale, Localization>([
  ['en_US', enUS],
  ['ru_RU', ruRU],
]);

export const getTheme = (colors: BrandThemeColors, lang: UnderscoreLocale) => {
  const palette = createPalette({
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
      contrastText: colors.secondaryContrast,
    },
    info: {
      main: '#1F33FF',
    },
    success: {
      main: '#009D23',
      light: '#6AFFAF',
    },
    error: {
      main: '#D93025',
    },
    background: {
      paper: '#FFFFFF',
      default: '#E2E2E2',
    },
    grey: {
      A100: '#424242',
      A200: '#717171',
      A400: '#C4C4C4',
    },
    warning: {
      main: '#FFC76B',
      light: '#FFF7CD',
    },
    ticketStatus: {
      deleted: '#1D1D1B',
      notAssigned: '#DFBE0F',
      opened: '#009D23',
      waiting: '#0288D1',
      development: '#E77C06',
      closed: '#C4C4C4',
    },
  });

  return createTheme(
    {
      palette,
      components: getOverrides(palette),
      typography: {
        caption: {
          color: palette.grey.A200,
        },
      },
    },
    notUndefined(gridLocalesMap.get(lang)),
    notUndefined(localesMap.get(lang))
  );
};
